// extracted by mini-css-extract-plugin
module.exports = {"inlineCode":"InlineCode-module--inlineCode--1N2-K"};